/**
 * Окно на 2D-чертеже: разрыв в стене и две тонкие линии — стеклопакет; импосты между
 * створками — поперечные черты (число створок знает тип окна в каталоге).
 *
 * Локальная система координат та же, что у двери: начало — левый край проёма,
 * ось X вдоль стены; поворот и сдвиг задаёт родитель через transform.
 */
import { windowItemOf } from "@/shared/catalog";
import type { OpeningShapeProps } from "../../door/2d/DoorShape";

export const WindowShape = ({
	opening,
	wallThickness,
	selected,
	mmPerPx,
	interactive,
	onPointerDown,
}: OpeningShapeProps) => {
	const t = wallThickness;
	const w = opening.width;
	const px = (n: number) => n * mmPerPx;
	const accent = selected ? "#2f6feb" : "#39414f";
	const sashes = windowItemOf(opening.item).sashes;
	const imposts = Array.from({ length: sashes - 1 }, (_, i) => (w * (i + 1)) / sashes);

	return (
		<g>
			{/* Разрыв в стене */}
			<rect x={0} y={-t / 2} width={w} height={t} fill="#ffffff" />
			{/* Стеклопакет */}
			<line x1={0} y1={-t / 5} x2={w} y2={-t / 5} stroke={accent} strokeWidth={px(1.5)} />
			<line x1={0} y1={t / 5} x2={w} y2={t / 5} stroke={accent} strokeWidth={px(1.5)} />
			{imposts.map((x) => (
				<line key={x} x1={x} y1={-t / 5} x2={x} y2={t / 5} stroke={accent} strokeWidth={px(1.5)} />
			))}
			{/* Откосы по краям проёма */}
			<line x1={0} y1={-t / 2} x2={0} y2={t / 2} stroke={accent} strokeWidth={px(1.5)} />
			<line x1={w} y1={-t / 2} x2={w} y2={t / 2} stroke={accent} strokeWidth={px(1.5)} />
			{/* Невидимая зона захвата для перетаскивания вдоль стены */}
			<rect
				data-role="opening"
				data-id={opening.id}
				x={0}
				y={-t / 2}
				width={w}
				height={t}
				fill="transparent"
				style={{
					cursor: interactive ? "grab" : "default",
					pointerEvents: interactive ? "auto" : "none",
				}}
				onPointerDown={onPointerDown}
			/>
		</g>
	);
};
